import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { Unit } from '@app/models/profile.model';
import { KirokuMenu, MENU_KIDS, NameLocalStorage } from '@app/models/record.model';
import { AccesslogService } from '@app/services/accesslog.service';
import { ApiService } from '@app/services/api.service';
import { StorageEnum } from '@app/shared/enum/storage';
import { AuthSelectors } from '@app/store/auth/auth.selectors';
import { ClearAuth, Login, Logout } from '@app/store/auth/auth.classes';
import { RemoveDataSet } from '@app/store/data/data.classes';
import { InitAliasId, SetWebView } from '@app/store/setting/setting.classes';
import { Select, Store } from '@ngxs/store';
import { filter, Observable, Subject, takeUntil } from 'rxjs';

const halfWidth = /^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  form: FormGroup;

  @Select(AuthSelectors.accessToken) accessToken$!: Observable<boolean>;
  @Select(AuthSelectors.selectedUnit) selectedUnit$!: Observable<Unit | null>;

  private onDestory$: Subject<void>;

  constructor(
    private fb: FormBuilder,
    private store: Store,
    private apiService: ApiService,
    private router: Router,
    private accesslog: AccesslogService
  ) {
    this.onDestory$ = new Subject();
    this.form = this.fb.group({
      corpprefix: [null, Validators.required],
      username: [null, [Validators.required, Validators.pattern(halfWidth)]],
      password: [null, Validators.required],
    });
    this.form.get('username')?.valueChanges.subscribe((data: string) => {
      if (!halfWidth.test(data)) {
        // Modify the value if it matches the pattern
        let value = data.split('').filter(x=>halfWidth.test(x)).join('');
        this.form.get('username')?.setValue(value);
      }
    })
  }

  get username() {
    return this.form.get('username') as FormControl;
  }
  get password() {
    return this.form.get('password') as FormControl;
  }
  get corpprefix() {
    return this.form.get('corpprefix') as FormControl;
  }

  ngOnInit(): void {
    // login remove state
    this.store.dispatch([new ClearAuth(), new RemoveDataSet(), new Logout(), new SetWebView(false)]);
    localStorage.removeItem(NameLocalStorage.CONDITION_FILTER);
    this.accessToken$
      .pipe(
        takeUntil(this.onDestory$),
        filter((accessToken) => !!accessToken)
      )
      .subscribe(() => {
        const selectedUnit = this.store.selectSnapshot(AuthSelectors.selectedUnit);
        if (selectedUnit) {
          this.router.navigate(['/']);
        } else {
          this.router.navigate(['', { outlets: { modal: ['unit-select'] } }]);
        }
      });

    this.selectedUnit$
      .pipe(
        takeUntil(this.onDestory$),
        filter((selectedUnit) => !!selectedUnit)
      )
      .subscribe(() => {
        // this.apiService.checkSyncS3().subscribe(() => {
        //   const nextActions = [
        //     new SetMenuList(),
        //     new SetButtonTitleList(),
        //   ];
        //   this.store.dispatch(nextActions);
        // });
        const actions = [
          new InitAliasId(),
          // new SetScheduleTitleList()
        ];
        this.store.dispatch(actions);
        // this.accesslog.login();
      });
  }

  ngOnDestroy(): void {
    this.onDestory$.next();
  }

  onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
    } else {
      const payload = {
        email: this.username.value,
        password: this.password.value,
        corpPrefix: this.corpprefix.value,
      };
      this.store.dispatch(new Login(payload));
    }
  }

  toList(updateFn: Function) {
    this.router.navigate(['home/list'], { replaceUrl: true, queryParamsHandling: "preserve" }).then(() => {
      updateFn();
      this.router.navigate([{ outlets: { modal: null, edit: null } }], { replaceUrl: true, queryParamsHandling: "preserve" })
    });
  }

  toKirokuList(configType: KirokuMenu) {
    const storage = () => {
      localStorage.setItem(StorageEnum.MENU, MENU_KIDS.KIROKU);
      localStorage.setItem(StorageEnum.MENU_ITEM, configType);
      window.dispatchEvent(new CustomEvent("menu-change", { detail: { key: 'change' } }));
    }
    this.toList(storage);
  }
}
